import { type ApiRequestOptions, apiRequest, loadSession } from '@servicedesk/ui';
import { acquireApiToken } from '../auth/msal';
import { authMode, config } from '../config';

async function authToken(): Promise<string> {
  if (authMode === 'entra') return acquireApiToken();
  if (authMode === 'magic') return loadSession()?.token ?? '';
  return '';
}

export async function api<T>(path: string, opts: ApiRequestOptions = {}): Promise<T> {
  const token = await authToken();
  return apiRequest<T>(config.apiBaseUrl, path, { ...opts, token });
}
